<template>
    <div id="app" class="bg-lightGrey">
        <app-result-screen
            v-if="showResult"
            :gameType="gameType"
            :levelStatuses="levelStatuses"
            :currentLevel="currentLevel"
            :maxLevel="getMaxLevel"
            :newScore="finalScore"
            :thresholdReached="thresholdReached"
            :showExamLink="showExamLink"
            :useLocalStorage="useLocalStorage"
        ></app-result-screen>
        <AGFHeader
            :class="checkBlur"
            :currentLevel="currentLevel"
            :levelStatuses="levelStatuses"
            :gameType="gameType"
        ></AGFHeader>
        <app-help v-if="showHelp" :gameType="gameType"></app-help>
        <app-score-header
            :class="checkBlur"
            :questionsLeft="questionsLeft"
            :displayScore="currentHighScore"
            :newScore="finalScore"
        ></app-score-header>
        <div class="colLeft" :class="checkBlur">
            <app-scoreMeter
                :score="0"
                :maxScore="0"
                :thresholdCounter="0"
                :threshold="threshold"
                :nrQuestions="nrQuestions"
                :questionsLeft="questionsLeft"
                :appleScore="score"
                :showAppleAnimation="showAppleAnimation"
            ></app-scoreMeter>
        </div>
        <div class="colRight" :class="checkBlur">
            <div v-if="gameType=='fruitmachine'">
                <app-fruitmachine-header
                    v-if="bankCreated && gameType=='fruitmachine'"
                    :gameType="gameType"
                    :title="getQuestionTitle"
                    :body="getQuestionBody"
                ></app-fruitmachine-header>
                <div class="questionContent" :class="getQuestionContentPosition">
                    <div v-if="gameType=='fruitmachine'" class="pointerRight">
                        <img v-if="isAnimating" src="./assets/images/pointer.png" class="pointer">
                        <img
                            v-if="!isAnimating"
                            src="./assets/images/pointer.png"
                            class="pointerBounce"
                        >
                    </div>
                    <div v-if="gameType=='fruitmachine'" class="pointerLeft">
                        <img v-if="isAnimating" src="./assets/images/pointer.png" class="pointer">
                        <img
                            v-if="!isAnimating"
                            src="./assets/images/pointer.png"
                            class="pointerBounce"
                        >
                    </div>
                    <div class="qcOuter"></div>
                    <div class="qcInner">
                        <app-wheel
                            v-if="gameType=='fruitmachine'"
                            :image="productImage"
                            :productName="productName"
                            :variation="variation"
                            :isAnimating="isAnimating"
                            :threshold="threshold"
                            :nrQuestions="nrQuestions"
                            :thresholdCounter="thresholdCounter"
                            :score="score"
                            :gameType="gameType"
                        ></app-wheel>
                    </div>
                </div>
                <app-answers
                    v-if="bankCreated"
                    :answers="answers"
                    :answeredCorrect="answeredCorrect"
                    :variation="variation"
                    :isAnswered="isAnswered"
                    :givenAnswer="givenAnswer"
                    :correctAnswer="correctAnswer.id"
                    :isAnimating="isAnimating"
                    :gameType="gameType"
                    :feedbackVisible="feedbackVisible"
                ></app-answers>
            </div>
            <div v-if="gameType=='training' && this.questionBank[this.currentQuestion] != undefined">
                <app-training-question
                    v-if="bankCreated"
                    :title="getQuestionTitle"
                    :isAnimating="isAnimating"
                ></app-training-question>
                <app-training-image
                    v-if="bankCreated"
                    :image="productImage"
                    :isAnimating="isAnimating"
                ></app-training-image>
                <div class="trainingBottom" v-bind:style="{'bottom': trainingBottomPos+'%'}">
                    <app-training-reply
                        v-if="bankCreated"
                        :body="getQuestionBody"
                        :isAnimating="isAnimating"
                    ></app-training-reply>
                    <app-answers
                        v-if="bankCreated"
                        :answers="answers"
                        :answeredCorrect="answeredCorrect"
                        :variation="variation"
                        :isAnswered="isAnswered"
                        :givenAnswer="givenAnswer"
                        :correctAnswer="correctAnswer.id"
                        :isAnimating="isAnimating"
                        :gameType="gameType"
                        :feedbackVisible="feedbackVisible"
                    ></app-answers>
                    <app-feedbackText :body="feedbackBody"></app-feedbackText>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { eventBus } from "./main";

import AGFHeader from "./components/AGFHeader.vue";
import FruitmachineHeader from "./components/FruitmachineHeader.vue";
import TrainingQuestion from "./components/TrainingQuestion.vue";
import TrainingImage from "./components/TrainingImage.vue";
import TrainingReply from "./components/TrainingReply.vue";
import Feedback from "./components/Feedback.vue";
import slotMachine from "./components/slotMachine.vue";
import FinalScore from "./components/finalScore.vue";
import Failed from "./components/failed.vue";
import scoreMeter from "./components/scoreMeter.vue";
import scoreHeader from "./components/scoreHeader.vue";
import Wheel from "./components/wheel.vue";
import Answers from "./components/Answers.vue";
import Help from "./components/help.vue";
import FeedbackText from "./components/FeedbackText.vue";

// JSON data
import data from "./assets/json/data.json";
import products from "./assets/json/products.json";
import questions from "./assets/json/questions.json";
import finalScoreVue from "./components/finalScore.vue";
import ResultScreen from "./components/ResultScreen.vue";

//mixins
import { ScormMixin } from "./mixins/Scorm.js"

export default {
    /*eslint no-console: ["error", { allow: ["log"] }] */
    name: "app",
    mixins: [ ScormMixin ],
    data() {
        return {
            jsonData: data,
            jsonProducts: products,
            jsonQuestions: questions,

            questionBank: [],
            comparisonBank: [],
            answers: [],
            canClick: true,
            restartBlur: false,
            
            currentQuestion: -1,
            nrQuestions: 0,
            questionsLeft: 0,

            levels: 3,
            currentLevel: 1,
            gameID: 0,
            isAnswered: false,
            givenAnswer: 0,
            correctAnswer: {},
            answeredCorrect: false,

            threshold: 0,
            thresholdCounter: 0,
            score: 0,
            showFinalScore: false,
            showFailedScore: false,

            isAnimating: false,

            timeOut: 2000,

            audioCorrect: new Audio(),
            audioIncorrect: new Audio(),
            audioWheel: new Audio(),

            highScores: [0, 0, 0, 0],

            showHelp: false,

            bankCreated: false,

            //statuses: 0: locked, 1:open, 2:completed



            // Om de twee verschillende versies van de game te kunnen publiceren moet er gewisseld worden tussen onderstaande gecommente code.
            // Wil je de Fruitmachine Game publiceren dan moet de code tussen FRUITMACHINE CODE actief zijn en de code tussen TRANING CODE inactief.
            // Wil je da Training game publiceren dan visa versa.


            // ************* FRUITMACHINE CODE ******************//
            gameType: "fruitmachine",
            levelStatuses: [1, 0, 0],
            localStorageName: "flwowe_asd87u93jaksld98321jpo_fruitmachine",
            // ************* FRUITMACHINE CODE ******************//


            // ************* TRAINING CODE ******************//
            // gameType: "training",
            // levelStatuses: [1],
            // localStorageName: "342398dfkajsl23910jaskld_training",
            // ************* TRAINING CODE ******************//

            showResult: false,
            showAppleAnimation: false,
            feedbackVisible: false,

            // SCORM & LMS

            // Wanneer useLocalStorage op true staat wordt localStorage gebruikt voor opslag van score .e.d. Wanneer deze op false staat, wordt SCORM gebruikt. 
            useLocalStorage: true,

            // false = geen link op result pagina naar toets. 
            showExamLink: true
        };
    },

    components: {
        AGFHeader,
        appFruitmachineHeader: FruitmachineHeader,
        appTrainingQuestion: TrainingQuestion,
        appTrainingImage: TrainingImage,
        appTrainingReply: TrainingReply,
        Feedback,
        slotMachine,
        appFinalScore: FinalScore,
        appScoreMeter: scoreMeter,
        appScoreHeader: scoreHeader,
        appWheel: Wheel,
        appAnswers: Answers,
        appFailed: Failed,
        appHelp: Help,
        appResultScreen: ResultScreen,
        appFeedbackText: FeedbackText
    },
    watch: {
        levelStatuses: {
            handler: function(newValue) {
                this.sp_setVariable("levelStatuses", newValue)
            },
            deep: true
        },
        highScores: {
            handler: function(newValue) {
                this.sp_setVariable("highScores", newValue)
            },
            deep: true
        },
    },
    computed: {
        trainingBottomPos() {
            if (this.feedbackVisible) {
                return 30;
            } else {
                return 2;
            }
        },
        feedbackBody() {
            return this.questionBank[this.currentQuestion].feedback;
        },
        getQuestionContentPosition() {
            if (this.gameType == "fruitmachine") {
                return "";
            } else {
                return "questionContentHigh";
            }
        },
        getQuestionTitle() {
            if (this.gameType == "fruitmachine") {
                return "Fruitmachine";
            }
            if (this.gameType == "training") {
                var result;
                if (
                    typeof this.questionBank[this.currentQuestion] ===
                    "undefined"
                ) {
                    result = "...";
                } else {
                    result = this.questionBank[this.currentQuestion].body;
                }

                return result;
            }
        },
        getQuestionBody() {
            if (this.gameType == "fruitmachine") {
                return "Wat zie je hier?";
            }
            if (this.gameType == "training") {
                var result;
                if (
                    typeof this.questionBank[this.currentQuestion] ===
                        "undefined" ||
                    typeof this.questionBank[this.currentQuestion] ===
                        "Undefined"
                ) {
                    result = "...";
                } else {
                    if (this.variation == 0) {
                        result = this.questionBank[this.currentQuestion]
                            .answerCorrect;
                    } else {
                        result = this.questionBank[this.currentQuestion]
                            .answerIncorrect;
                    }
                }

                return result;
            }
        },
        getMaxLevel() {
            return this.levelStatuses.length;
        },
        currentHighScore() {
            return this.highScores[this.currentLevel];
        },
        thresholdReached() {
            if (this.score >= this.threshold) {
                return true;
            } else {
                return false;
            }
        },
        finalScore() {
            console.log("calculating result")
            var result = Math.round((this.score / this.nrQuestions) * 100);
            if( result > 100) {
                result = 100
            }
            return result
        },
        checkBlur() {
            if (this.showResult || this.showResult || this.restartBlur) {
                return "blur";
            } else {
                return;
            }
        },
        // The product displayed in the wheel slot position
        productImage() {
            if (this.currentQuestion >= 0) {
                return this.questionBank[this.currentQuestion].image;
            }
        },
        // Name of the displayed producted
        productName() {
            if (this.currentQuestion >= 0) {
                return this.questionBank[this.currentQuestion].name;
            }
        },
        // Variation of the question: 0 = image->text, 2 = text->image (Fruitmachine)
        // or Correct statement, false statement (training)
        variation() {
            if (this.currentQuestion >= 0) {
                return this.questionBank[this.currentQuestion].variation;
            }
        }
    },
    methods: {
        setHighscore() {
            if (
                this.highScores[this.currentLevel] < this.finalScore &&
                this.thresholdReached
            ) {
                this.$set(this.highScores, this.currentLevel, this.finalScore);
            }
        },
        restart() {
            this.score = 0;
            this.currentQuestion = -1;
            this.nrQuestions = 0;
            this.questionsLeft = 0;
            this.showFinalScore = false;
            this.showFailedScore = false;
            this.showAppleAnimation = false;
            if (this.gameType == "fruitmachine") {
                this.createQuestionBank();
            } else {
                this.createQuestionBanktraining();
            }
        },
        nextLevel() {
            this.currentLevel++;
            if (this.currentLevel > 4) {
                this.currentLevel = 4;
            }
            this.restart();
        },
        selectLevel(level) {
            this.currentLevel = level;
            if (this.gameType == "fruitmachine") {
                this.createQuestionBank();
            } else {
                this.createQuestionBanktraining();
            }
        },

        createQuestionBanktraining() {
            this.canClick = false;
            this.showFinalScore = false;
            this.showFailedScore = false;
            this.gameID = Math.random(1000000000);
            this.nrQuestions = 31;
            this.questionsLeft = this.nrQuestions;
            this.threshold = 25;
            this.questionBank = new Array();
            //filter on products on their difficulty first
            var training = this.jsonQuestions.questions;
            this.questionBank = [];
            for (var i = 0; i < training.length; i++) {
                var curScenario = training[i];
                curScenario.variation = this.randomRange(0, 2);
                this.questionBank.push(curScenario);
            }
            this.questionBank = this.shuffle(this.questionBank);
            this.questionBank = this.questionBank.splice(0, this.nrQuestions);
            // All done generating the questionbank. Show question now.
            this.bankCreated = true;
            this.animateToNextQuestion();
        },

        createQuestionBank() {
            this.canClick = false;
            this.showFinalScore = false;
            this.showFailedScore = false;
            this.gameID = Math.random(1000000000);
            this.nrQuestions = 30;
            this.questionsLeft = this.nrQuestions;
            this.threshold = 20;
            this.questionBank = new Array();
            this.comparisonBank = new Array();

            var products = this.jsonProducts.products;
            this.questionBank = [];
            for (var i = 0; i < products.length; i++) {
                var curProduct = products[i];
                var curComparisonProduct;

                if (this.currentLevel == 1) {

                    if (curProduct.difficulty == 2) {
                        curProduct.variation = this.randomRange(0, 2);
                        this.questionBank.push(curProduct);
                        this.comparisonBank.push(curProduct);
                    }
                }
                if (this.currentLevel == 2) {

                    if (curProduct.difficulty == 1) {
                        curProduct.variation = this.randomRange(0, 2);
                        this.questionBank.push(curProduct);
                    }
                    if (
                        curProduct.difficulty == 1 ||
                        curProduct.difficulty == 2
                    ) {
                        this.comparisonBank.push(curProduct);
                    }
                }
                if (this.currentLevel == 3) {

                    if (curProduct.difficulty == 2) {
                        curProduct.variation = this.randomRange(0, 2);
                        this.questionBank.push(curProduct);
                    }
                    if (
                        curProduct.difficulty == 1 ||
                        curProduct.difficulty == 2
                    ) {
                        this.comparisonBank.push(curProduct);
                    }
                }
            }
            this.questionBank = this.shuffle(this.questionBank);
            this.questionBank = this.questionBank.splice(0, this.nrQuestions);

            this.bankCreated = true;
            this.animateToNextQuestion();
        },
        // *****************************************
        getAnswerX(i) {
            if (i == 0 || i == 2) {
                return 0;
            } else {
                return 1;
            }
        },
        getAnswerY(i) {
            if (i == 0 || i == 1) {
                return 0;
            } else {
                return 1;
            }
        },
        showFeedback() {
            this.feedbackVisible = true;
            if (this.givenAnswer == this.correctAnswer.id) {
                this.answeredCorrect = true;
                this.thresholdCounter++;
                this.score++;
                this.thresholdCounter = this.threshold;
            } else {
                this.answeredCorrect = false;

                var curQuestion = this.questionBank[this.currentQuestion];
                var nextIndex = this.currentQuestion + 3;
                if (nextIndex > this.questionBank.length) {
                    nextIndex = this.questionBank.length;
                }
                if (this.gameType == "fruitmachine") {
                    this.questionBank.splice(nextIndex, 0, curQuestion);
                }
            }


            eventBus.$emit("doApple", this.answeredCorrect);

            this.playAudioFeedback();
            for (var i = 0; i < this.answers.length; i++) {
                var curAnswer = this.answers[i];
            }

            if (this.gameType == "fruitmachine") {
                setTimeout(() => {
                    this.animateToNextQuestion();
                }, this.timeOut);
            }
        },
        playAudioFeedback() {
            var audio = new Audio();
            if (this.answeredCorrect) {
                this.audioCorrect.play();
            } else {
                this.audioIncorrect.play();
            }
        },

        animateToNextQuestion() {
            this.canClick = false;
            this.feedbackVisible = false;
            if (this.currentQuestion + 1 >= this.nrQuestions) {
                this.setHighscore();
                this.showScore();
            } else {
                this.isAnimating = true;
                this.isAnswered = false;
                if (this.gameType == "fruitmachine") {
                    this.audioWheel.play();
                }
                setTimeout(() => {
                    this.nextQuestion();
                }, 1000);
            }
        },
        nextQuestion() {
            if (this.currentQuestion >= 0 && this.answeredCorrect == false) {
                var curQ = this.questionBank[this.currentQuestion];
                if (curQ.variation == 0) {
                    curQ.variation = 1;
                } else {
                    curQ.variation = 0;
                }
            }
            this.isAnimating = false;
            this.answered = false;
            this.givenAnswer = 0;
            this.isAnswered = false;
            this.answers = [];
            this.currentQuestion++;


            if (this.gameType == "training") {
                if (this.variation == 0) {
                    this.correctAnswer = { id: 0, name: "Goed" };
                } else {
                    this.correctAnswer = { id: 1, name: "Fout" };
                }
                this.answers.push({ id: 0, name: "Goed" });
                this.answers.push({ id: 1, name: "Fout" });
                this.canClick = true;
            }


            if (this.gameType == "fruitmachine") {
                this.answers.push(this.questionBank[this.currentQuestion]);
                this.correctAnswer = this.questionBank[this.currentQuestion];

                var compareIds = this.shuffle(
                    this.arrayRange(0, this.comparisonBank.length - 1)
                );

                var n = 0;
                while (this.answers.length < 4) {
                    var curCompareAnswer = this.comparisonBank[compareIds[n]];
                    if (curCompareAnswer.id == this.correctAnswer.id) {
                        n++;
                    } else {
                        // LEVEL 1
                        if (
                            this.currentLevel == 1 &&
                            curCompareAnswer != undefined &&
                            curCompareAnswer != null &&
                            curCompareAnswer != "" &&
                            curCompareAnswer.category != this.correctAnswer.category
                        ) {
                            this.answers.push(curCompareAnswer);
                        }
                        // LEVEL 2
                        if (
                            this.currentLevel == 2 &&
                            curCompareAnswer != undefined &&
                            curCompareAnswer != null &&
                            curCompareAnswer != ""
                        ) {

                            if (
                                curCompareAnswer.category ==
                                this.correctAnswer.category
                            ) {
                                this.answers.push(curCompareAnswer);
                            }
                        }
                        // LEVEL 3
                        if (
                            this.currentLevel == 3 &&
                            curCompareAnswer != undefined &&
                            curCompareAnswer != null &&
                            curCompareAnswer != ""
                        ) {
                            if (
                                curCompareAnswer.category ==
                                this.correctAnswer.category
                            ) {
                                this.answers.push(curCompareAnswer);
                            }
                        }
                        // LEVEL 4
                        if (
                            this.currentLevel == 4 &&
                            curCompareAnswer != undefined &&
                            curCompareAnswer != null &&
                            curCompareAnswer != ""
                        ) {
                            if (
                                curCompareAnswer.category ==
                                this.correctAnswer.category
                            ) {
                                this.answers.push(curCompareAnswer);
                            }
                        }
                    }
                    n++;
                }
                this.answers = this.shuffle(this.answers);
                this.canClick = true;
            }
        },
        // *****************************************

        countInArray(array, what) {
            return array.filter(item => item == what).length;
        },
        randomRange(min, max) {
            return Math.floor(Math.random() * max) + min;
        },
        numberArrayFromTo(from, to) {
            var array = [];
            for (var i = 0; i < to - from + 1; i++) {
                array.push(i + from);
            }
            return array;
        },
        shuffle(array) {
            var j, x, i;
            for (i = array.length - 1; i > 0; i--) {
                j = Math.floor(Math.random() * (i + 1));
                x = array[i];
                array[i] = array[j];
                array[j] = x;
            }
            return array;
        },
        arrayRange(start, end) {
            return new Array(end - start + 1)
                .fill(undefined)
                .map((_, i) => i + start);
        },
        showScore() {
            this.showAppleAnimation = true;
            if (this.thresholdReached) {
                this.showResult = true;
            } else {
                setTimeout(() => {
                    this.showResult = true;
                }, 1500);
            }
        }
    },
    created() {
        eventBus.$on("lmsSetComplete", props => {
            this.scorm_complete()
        });

        eventBus.$on("nextLevel", props => {
            this.showResult = false;
            this.nextLevel();
        });
        eventBus.$on("nextQuestion", props => {
            this.animateToNextQuestion();
        });
        eventBus.$on("tryAgain", props => {
            this.showResult = false;
            this.restart();
        });
        eventBus.$on("answerWasGiven", props => {
            if (this.canClick) {
                this.questionsLeft--;
                this.isAnswered = true;
                this.givenAnswer = props.id;
                this.showFeedback();
            }
        });
        eventBus.$on("levelWasSelected", level => {
            if (this.canClick) {
                this.currentLevel = level;
                this.restart();
            }
        });
        eventBus.$on("created", level => {
            this.currentLevel = level;
            this.restart();
        });
        eventBus.$on("toggleHelp", i => {
            this.showHelp = !this.showHelp;
        });
        eventBus.$on("updateLevelStatus", newStatus => {
            var curStatus = this.levelStatuses[this.currentLevel - 1];
            var nextLevel = this.currentLevel;

            if (newStatus > curStatus) {
                this.$set(this.levelStatuses, this.currentLevel - 1, newStatus);
            }
            if (nextLevel < this.levelStatuses.length && newStatus == 2) {
                var nextLevelStatus = this.levelStatuses[nextLevel];
                if (nextLevelStatus < 1) {
                    this.$set(this.levelStatuses, nextLevel, 1);
                }
            }
        });
    },
    mounted() {

        this.scorm_init();
        if(this.spData.highScores != null && this.spData.highScores != undefined) {
            this.highScores = this.spData.highScores;
        }
        if(this.spData.levelStatuses != null && this.spData.levelStatuses != undefined ) {
            this.levelStatuses = this.spData.levelStatuses;
        }
        window.onbeforeunload = function() {
            
        };

        this.audioCorrect.src = "audio/correct.mp3";
        this.audioIncorrect.src = "audio/incorrect.mp3";
        this.audioWheel.src = "audio/wheel.mp3";
        if (this.gameType == "fruitmachine") {
            this.createQuestionBank();
        }
        if (this.gameType == "training") {
            this.createQuestionBanktraining();
        }
    }
};
</script>

<style>
html,
body {
    width: 61vh;
    height: 100vh;
    overflow: hidden;
    margin: 0 auto;
    padding: 0;
    background: url(assets/images/bg.jpg) no-repeat center center fixed;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    -webkit-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.25);
    -moz-box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.25);
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.25);
}
@font-face {
    font-family: "ObelixPro";
    src: url("assets/fonts/ObelixPro-Bold.woff") format("woff");
    font-weight: bold;
    font-style: normal;
}

@font-face {
    font-family: "ObelixPro";
    src: url("assets/fonts/ObelixPro.woff") format("woff");
    font-weight: normal;
    font-style: normal;
}

@font-face {
    font-family: "ObelixPro";
    src: url("assets/fonts/ObelixPro-BoldItalic.woff") format("woff");
    font-weight: bold;
    font-style: italic;
}

@font-face {
    font-family: "ObelixPro";
    src: url("assets/fonts/ObelixPro-Italic.woff") format("woff");
    font-weight: normal;
    font-style: italic;
}

.txt-white {
    color: #ffffff;
}
.txt-mediumGrey {
    color: #7f7f7f;
}
.txt-darkGrey {
    color: #555555;
}
.bold {
    font-weight: bold;
}
.italic {
    font-weight: italic;
}
.round {
    border-radius: 50%;
}

.blur {
    filter: blur(10px);
}
#app {
    width: 100%;
    height: 100%;
    font-family: "ObelixPro";
    font-weight: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
}
button {
    font-family: "ObelixPro";
    font-weight: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
h1 {
    font-weight: bold;
    font-size: 3.5vh;
}
h2 {
    font-weight: bold;
    font-size: 2.5vh;
    /* font-size: calc(0.4em + 1vw); */
    margin: 2% 10% 3% 10%;
    letter-spacing: 0.1em;
}
h3 {
    font-weight: bold;
    /* font-size: calc(0.3em + 2.5vw); */
    font-size: 2vh;
    margin: 2% 10% 3% 10%;
    letter-spacing: 0.1em;
}
h4 {
    font-weight: bold;
    /* font-size: calc(0.25em + 2vw); */
    font-size: 1.5vh;
    margin-top: 3%;
    margin-bottom: 2%;
    letter-spacing: 0.1em;
}
/* @media only screen and (min-width: 800px) {
    #app {
        margin-top: 2.5%;
        height: 90%;
        width: 50%;
        position: relative;
        -webkit-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
        -moz-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
    }
}
@media only screen and (min-width: 1200px) {
    #app {
        margin-top: 2.5%;
        height: 90%;
        width: 30%;
        position: relative;
        -webkit-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
        -moz-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.5);
    }
    h3 {
        font-size: calc(1em);
    }
    h4 {
        font-size: calc(0.8em);
    }
} */
.colLeft,
.colRight {
    height: 100%;
    background: #fff;
    display: inline-block;
    position: relative;
    float: left;
    background: rgba(255, 196, 0, 1);
    background: -moz-linear-gradient(
        top,
        rgba(255, 196, 0, 1) 0%,
        rgba(255, 196, 0, 1) 32%,
        rgba(219, 88, 0, 1) 68%,
        rgba(219, 88, 0, 1) 100%
    );
    background: -webkit-gradient(
        left top,
        left bottom,
        color-stop(0%, rgba(255, 196, 0, 1)),
        color-stop(32%, rgba(255, 196, 0, 1)),
        color-stop(68%, rgba(219, 88, 0, 1)),
        color-stop(100%, rgba(219, 88, 0, 1))
    );
    background: -webkit-linear-gradient(
        top,
        rgba(255, 196, 0, 1) 0%,
        rgba(255, 196, 0, 1) 32%,
        rgba(219, 88, 0, 1) 68%,
        rgba(219, 88, 0, 1) 100%
    );
    background: -o-linear-gradient(
        top,
        rgba(255, 196, 0, 1) 0%,
        rgba(255, 196, 0, 1) 32%,
        rgba(219, 88, 0, 1) 68%,
        rgba(219, 88, 0, 1) 100%
    );
    background: -ms-linear-gradient(
        top,
        rgba(255, 196, 0, 1) 0%,
        rgba(255, 196, 0, 1) 32%,
        rgba(219, 88, 0, 1) 68%,
        rgba(219, 88, 0, 1) 100%
    );
    background: linear-gradient(
        to bottom,
        rgba(255, 196, 0, 1) 0%,
        rgba(255, 196, 0, 1) 32%,
        rgba(219, 88, 0, 1) 68%,
        rgba(219, 88, 0, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffc400', endColorstr='#db5800', GradientType=0 );
}
.colLeft {
    width: 15%;
    position: relative;
}
.colRight {
    width: 85%;
}

.trainingBottom {
    position: absolute;
    width: 100%;
    height: 45%;
    z-index: 6;
    transition: all 0.75s ease-in-out;
}
.questionContent {
    display: inline-block;
    position: absolute;
    top: 15%;
    left: 0;
    width: 98%;
    height: 35%;
    border-bottom-right-radius: 14px;
    border-bottom-left-radius: 14px;
    background: rgba(255, 217, 0, 1);
    background: -moz-linear-gradient(
        top,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    background: -webkit-gradient(
        left top,
        left bottom,
        color-stop(0%, rgba(255, 217, 0, 1)),
        color-stop(54%, rgba(255, 217, 0, 1)),
        color-stop(75%, rgba(255, 153, 0, 1)),
        color-stop(100%, rgba(219, 88, 0, 1))
    );
    background: -webkit-linear-gradient(
        top,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    background: -o-linear-gradient(
        top,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    background: -ms-linear-gradient(
        top,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    background: linear-gradient(
        to bottom,
        rgba(255, 217, 0, 1) 0%,
        rgba(255, 217, 0, 1) 54%,
        rgba(255, 153, 0, 1) 75%,
        rgba(219, 88, 0, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffd900', endColorstr='#db5800', GradientType=0 );
}
.questionContentHigh {
    top: 10%;
}
.qcOuter {
    position: absolute;
    top: 0;
    left: 5%;
    width: 90%;
    height: 90%;
    z-index: 2;
    background: rgba(165, 69, 5, 1);
    background: -moz-linear-gradient(
        top,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    background: -webkit-gradient(
        left top,
        left bottom,
        color-stop(0%, rgba(165, 69, 5, 1)),
        color-stop(22%, rgba(255, 153, 0, 1)),
        color-stop(44%, rgba(219, 88, 0, 1)),
        color-stop(72%, rgba(255, 217, 0, 1)),
        color-stop(80%, rgba(255, 153, 0, 1)),
        color-stop(100%, rgba(255, 217, 0, 1))
    );
    background: -webkit-linear-gradient(
        top,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    background: -o-linear-gradient(
        top,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    background: -ms-linear-gradient(
        top,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    background: linear-gradient(
        to bottom,
        rgba(165, 69, 5, 1) 0%,
        rgba(255, 153, 0, 1) 22%,
        rgba(219, 88, 0, 1) 44%,
        rgba(255, 217, 0, 1) 72%,
        rgba(255, 153, 0, 1) 80%,
        rgba(255, 217, 0, 1) 100%
    );
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a54505', endColorstr='#ffd900', GradientType=0 );
}
.qcInner {
    width: 88%;
    height: 86%;
    position: absolute;
    top: 2%;
    left: 6%;
    z-index: 3;
    background: #7c0303;
}

.pointerLeft,
.pointerRight {
    position: absolute;
    z-index: 5;
    right: 0;
    width: 20%;
    filter: drop-shadow(-10px 10px 10px rgba(0, 0, 0, 0.45));
    -webkit-filter: drop-shadow(-10px 10px 10px rgba(0, 0, 0, 0.45));
    -moz-filter: drop-shadow(-10px 10px 10px rgba(0, 0, 0, 0.45));
}
.pointerRight {
    right: 0;
    top: 40%;
}
.pointerLeft {
    left: 0;
    top: 40%;
    -moz-transform: scaleX(-1);
    -o-transform: scaleX(-1);
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
    filter: FlipH;
    -ms-filter: "FlipH";
}
.pointer,
.pointerBounce {
    width: 100%;
}
.pointerBounce {
    transform-origin: 100% 25%;
    -webkit-animation: pointerBounce 1s;
    -moz-animation: pointerBounce 1s;
    animation: pointerBounce 1s;
}
.pointer {
    transform-origin: 100% 25%;
    -webkit-animation: pointerAni 0.1s infinite;
    -moz-animation: pointerAni 0.1s infinite;
    animation: pointerAni 0.1s infinite;
}
@keyframes pointerAni {
    0% {
        -webkit-transform: rotate(-15deg);
        -ms-transform: rotate(-15deg);
        transform: rotate(-15deg);
    }
    25% {
        -webkit-transform: rotate(-30deg);
        -ms-transform: rotate(-30deg);
        transform: rotate(-30deg);
    }
    50% {
        -webkit-transform: rotate(30deg);
        -ms-transform: rotate(30deg);
        transform: rotate(30deg);
    }
    50% {
        -webkit-transform: rotate(-30deg);
        -ms-transform: rotate(-30deg);
        transform: rotate(-30deg);
    }
    100% {
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        transform: rotate(0deg);
    }
}
@keyframes pointerBounce {
    0% {
        -webkit-transform: rotate(-30deg);
        -ms-transform: rotate(-30deg);
        transform: rotate(-30deg);
    }
    25% {
        -webkit-transform: rotate(20deg);
        -ms-transform: rotate(20deg);
        transform: rotate(20deg);
    }
    50% {
        -webkit-transform: rotate(-10deg);
        -ms-transform: rotate(-10deg);
        transform: rotate(-10deg);
    }
    75% {
        -webkit-transform: rotate(5deg);
        -ms-transform: rotate(5deg);
        transform: rotate(5deg);
    }
    100% {
        -webkit-transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        transform: rotate(0deg);
    }
}

.container {
}

/* ANIMATIONS & TRANSITIONS */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.75s;
}

.fade-enter,
.fade-leave-active {
    opacity: 0;
}

.fadeSlow-enter-active,
.fadeSlow-leave-active {
    transition: opacity 2s;
}

.fadeSlow-enter,
.fadeSlow-leave-active {
    opacity: 0;
}
</style>
